import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import CategoriesEdit from "../../../../components/_utils/AccountCreationComponents/CategoriesEdit";
import { viewAccountDetail } from "../../../../redux/features/verifyPAN/verifyPAN";

import { beneCategories } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { editBeneficiary } from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import { isImmutableDefault } from "@reduxjs/toolkit";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";

const FieldForceEditCategories = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const { id } = params;
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [sliceCategories, setSliceCategories] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
  const [openPopEdit, setOpenPopEdit] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [showAlertCategories, setShowAlertCategories] = useState(false);
  const [buttondisable, setButtondisable] = useState(false);
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    contact_no: "",
    email_id: "",
    gstin: "",
    name: "",
    categories: null,
    panNumber: "",
  });

  const [initialCategories, setInitialCategories] = useState([]);

  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.verify,
  );
  const sliceCategory = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  const sliceCategoryLoading = useSelector(
    (state) => state.beneAllVerification.isTransCateLoading,
  );

  const { editBeneficiaryData, editBeneficiaryLoading } = useSelector(
    (state) => state.beneCreateAccount,
  );

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        let response1 = await dispatch(viewAccountDetail({ id }));
        if (
          response1?.error?.message === "Request failed with status code 404"
        ) {
          navigate("*");
          return;
        }

        let response2 = await dispatch(beneCategories(id));
        if (
          response2?.error?.message === "Request failed with status code 404"
        ) {
          navigate("*");
          return;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCategoryData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    setSliceCategories(
      sliceCategory.filter((category) => category?.active === "Y"),
    );
  }, [sliceCategory]);

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const beneficiaryData = viewAccountDetailData?.beneficiary_accounts[0];
      const selectedCategoriesArray = beneficiaryData.category
        .split(",")
        .filter((val) => val !== "");
      setSelectedCategories(selectedCategoriesArray);
      setInitialCategories(selectedCategoriesArray);
      setPayload((prev) => ({
        ...prev,
        categories: beneficiaryData.category,
      }));

      dispatch(beneCategories({ categories: beneficiaryData.category }));
    }
  }, [dispatch, viewAccountDetailData, viewAccountDetailLoading]);

  useEffect(() => {
    const allInitiallyAssigned =
      initialCategories.length === sliceCategories.length;

    const sameAsInitial =
      selectedCategories.length === initialCategories.length &&
      selectedCategories.every((cat) => initialCategories.includes(cat));

    if (
      initialCategories.length === GlobalConfiguration.lengthCheckZero &&
      selectedCategories.length === GlobalConfiguration.lengthCheckZero
    ) {
      setIsUpdateDisabled(false);
    } else if (sameAsInitial) {
      setIsUpdateDisabled(true);
    } else if (
      allInitiallyAssigned &&
      selectedCategories.length === GlobalConfiguration.lengthCheckZero
    ) {
      setIsUpdateDisabled(false);
    } else {
      setIsUpdateDisabled(false);
    }

    setSelectAllChecked(
      sliceCategories.length > GlobalConfiguration.lengthCheckZero &&
        selectedCategories.length === sliceCategories.length,
    );
  }, [selectedCategories, sliceCategories, initialCategories]);

  const handleBack = () => {
    if (!isUpdateDisabled) {
      setOpenPopEdit(true);
    } else {
      navigate(-1);
    }
  };

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      nextHoverOption: "black",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsEnabled: !isUpdateDisabled && !buttondisable,
      stepperText: "Categories",
    },
  ];

  useEffect(() => {
    if (editBeneficiaryData?.status === true) {
      navigate(
        `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_categories_success/${id}`,
      );
    }
  }, [editBeneficiaryData]);

  const handleUpdateAccount1 = async () => {
    if (
      (selectedCategories?.length ===
        sliceCategory.filter((category) => category?.active === "Y")?.length &&
        !showAlertCategories) ||
      (!selectedCategories?.length && !showAlertCategories)
    ) {
      setShowAlertCategories(true);
    } else {
      const response = await dispatch(
        editBeneficiary({
          id: id,
          category: selectedCategories.toString(),
          navigate,
        }),
      );

      if (response?.error?.message === "Rejected") {
        setButtondisable(false);
      } else {
        setButtondisable(true);
      }
      setShowAlertCategories(false);
    }
  };

  const toggleSelectAll = () => {
    if (selectedCategories.length === sliceCategories.length) {
      setSelectedCategories([]);
    } else {
      setSelectedCategories(sliceCategories.map((cat) => cat.name));
    }
  };

  const handleCategorySelect = (categoryId) => {
    const category = sliceCategories.find((c) => c.id === categoryId);
    if (!category) return;

    const updated = selectedCategories.includes(category.name)
      ? selectedCategories.filter((name) => name !== category.name)
      : [...selectedCategories, category.name];

    setSelectedCategories(updated);
  };

  const handleConfirm = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };

  const sortedCategories = sliceCategories;

  return (
    <div
      className="edit_bank_con_main !h-screen"
      style={{
        overflowY: false ? "hidden" : "hidden",
      }}
    >
      {showAlertCategories && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"It is unsafe to proceed"}
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            headerWithIcon="https://q2pay.in/new_assets/common/dashboard/alert.svg"
            subtext="Assigning all categories to a single account is highly unsafe.
                  It is recommended to limit the number of categories assigned
                  to the account."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setShowAlertCategories(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleUpdateAccount1}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {openPopEdit && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"It is unsafe to proceed"}
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            headerWithIcon="https://q2pay.in/new_assets/common/dashboard/alert.svg"
            subtext="Assigning all categories to a single account is highly unsafe.
                  It is recommended to limit the number of categories assigned
                  to the account."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setShowAlertCategories(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleUpdateAccount1}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="w-full z-z-index-header flex-col justify-center items-center Qsmd:flex hidden">
        <div className="h-navbar-breadcrumb-height" />
        <div className="w-full Qlg:w-std-width relative min-h-stepper-height">
          <PrimaryStepper
            activeStep={0}
            handleForwardAction={handleUpdateAccount1}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>
      </div>

      {/* <div className="Qsmd:h-navbar-breadcrumb-height min-h-[var(--navbar-height)]"></div> */}
      <div className="top_bar_btn_resp_edit Qsmd:hidden flex">
        <TopNavComponent
          isFormattingNotRequired
          topNavHeader={"Field force account"}
          topNavSubText="Edit categories"
          handleBack={handleBack}
        />
        <div
          className={`h-mobile-create-header ${
            !isUpdateDisabled
              ? "bg-Button-green cursor-pointer"
              : "bg-text-secondary cursor-not-allowed"
          } fixed bottom-bottom-base w-width-full text-text-primary items-center justify-center flex font-semibold z-z-index-modal`}
          onClick={!isUpdateDisabled ? handleUpdateAccount1 : undefined}
        >
          Update
        </div>
      </div>
      <div className="h-navbar-height block Qsmd:hidden flex-shrink-0 flex-grow-0"></div>
      <div className="w-full overflow-auto pb-padding-lg Qsmd:pb-padding-base mx-auto">
        <div className="z-z-index-base relative w-max-content-width mx-auto Qsmd:w-full">
          <div className="Qsmd:p-padding-md p-padding-sm"></div>
          <div className="Qsmd:max-w-mobile-width-sm max-w-full">
            <CategoriesEdit
              sortedCategories={sortedCategories}
              selectedCategories={selectedCategories}
              setSelectedCategories={setSelectedCategories}
              selectAllChecked={selectAllChecked}
              toggleSelectAll={toggleSelectAll}
              handleCategorySelect={handleCategorySelect}
              Title={"Assign Categories"}
              SubTitle="Not selecting categories will assign all, including future ones, to this account. This is not recommended for security reasons."
              TitleFontcolor="text-primary"
              TextSize="font-md"
              SubTitleFontcolor="text-secondary"
              SubTitleTextSize="font-xs"
              TitleFontWeight="semibold"
              SubTitleFontWeight="normal"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldForceEditCategories;
